import { useState, useEffect } from 'react'
import { toast } from '@sales-center/components'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { getActiveServices } from '../api'
import { IActiveServiceDetail } from '../typings'

type State = {
  loading: boolean
  activeServices: IActiveServiceDetail[]
}

export const useGetActiveServicesOnMount = (opportunityId: number) => {
  const dispatch = useAppDispatch()

  const [state, setState] = useState<State>(() => ({
    loading: true,
    activeServices: [],
  }))

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      const result = await dispatch(getActiveServices(opportunityId))

      if (!mounted) return

      if (getActiveServices.fulfilled.match(result)) {
        setState({ loading: false, activeServices: result.payload })
      } else {
        setState({ loading: false, activeServices: [] })
        toast.error('Error loading active services.')
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, opportunityId])

  return { ...state }
}
